var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseBlueIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6733 10.4677C12.0237 10.8182 12.0237 11.3867 11.6733 11.7372C11.3229 12.0876 10.7543 12.0876 10.4039 11.7372L5.98439 7.28477L1.53349 11.7357C1.18307 12.0861 0.614514 12.0861 0.264052 11.7357C-0.0864091 11.3852 -0.0863717 10.8167 0.264052 10.4662L4.71644 6.01683L0.262818 1.53227C-0.087606 1.18185 -0.087606 0.613293 0.262818 0.262832C0.613242 -0.0876293 1.1818 -0.087592 1.53226 0.262832L5.98439 4.74889L10.4353 0.29799C10.7857 -0.0524338 11.3543 -0.0524338 11.7047 0.29799C12.0552 0.648414 12.0552 1.21697 11.7047 1.56743L7.25233 6.01683L11.6733 10.4677Z",
    fill: "#6CB6E3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBlueIcon);
export default __webpack_public_path__ + "static/media/closeBlueIcon.43123554e7d168c28965617fae62920b.svg";
export { ForwardRef as ReactComponent };